import { LISTS_DETAIL_PATH, LISTS_SPAN_PATH } from '@/app/constants';
import { generatePath, Link, useLocation } from 'react-router-dom';
import classes from './CustomListBadgeLink.module.css';
import { CustomListBadge } from '@/views/list/custom-lists/CustomListBadge';
import { type CustomListBasics } from '@/features/types';

export default function CustomListBadgeLink(
  props: CustomListBasics & {
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
    spanId?: string;
  }
) {
  const { listId: id, name, spanId } = props;
  const location = useLocation();

  const url = spanId
    ? generatePath(LISTS_SPAN_PATH, { id, spanId })
    : generatePath(LISTS_DETAIL_PATH, { id });

  return (
    <Link
      onClick={props.onClick}
      to={{ pathname: url, search: location.search }}
      className={classes.link}
    >
      <CustomListBadge name={name} className={classes.badgeLink} />
    </Link>
  );
}
